import AppImage from '@/components/ui/AppImage';
import img from '../../img/about_me_photo.jpg';

export default function BioSection() {
  return (
    <section className="py-16">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Portrait */}
        <div className="reveal">
          <div className="relative aspect-[3/4] rounded-2xl overflow-hidden">
            <AppImage
              src={img.src}
              alt="Professional photographer Ryan Sukeena"
              className="w-full h-full object-cover"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent" />
          </div>
        </div>

        {/* Bio Text */}
        <div className="space-y-6 reveal delay-200">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-2">Ryan Sukeena</h2>
            <p className="text-xl text-muted-foreground">Professional Photographer</p>
          </div>

          <div className="space-y-4 text-muted-foreground leading-relaxed">
            <p>
              Hi, I’m Ryan — a Delaware-based photographer with a passion for capturing moments and
              machines in their best light.
            </p>

            <p>
              I started my journey four years ago shooting automotive photography as a hobby. What
              began as taking photos at local car meets quickly turned into a deep appreciation for
              composition, lighting, and storytelling through imagery. Over time, that passion
              expanded beyond cars and into real estate and event photography, allowing me to work
              with a wide range of clients and environments.
            </p>

            <p>
              Whether I’m highlighting the sharp lines of a performance car, showcasing a home for
              sale, or capturing the energy of a live event, my goal is always the same: create
              clean, intentional images that make an impact.
            </p>

            <p className="text-white font-medium italic">
              "Every photograph is a story waiting to be told. My job is to capture it beautifully."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
